import React from 'react';
import { Gift } from 'lucide-react';
const IMG_RECETARIO = 'https://cdn.magicpatterns.com/uploads/cCEEGmoLnawrgKmm7fpLEG/PORTADA_RECETARIO_BUDINES.jpg';
const IMG_BONO_1 = 'https://cdn.magicpatterns.com/uploads/juiUaShqgxjJgCLuuuEQU7/BONO_1_EMPRENDER.jpg';
const IMG_BONO_2 = 'https://cdn.magicpatterns.com/uploads/dtj7Ncvbp3EfJJApgyx8ef/BONO_2_CONSERVACION.jpg';
const IMG_BONO_3 = 'https://cdn.magicpatterns.com/uploads/oDpiJdc3skG91BUSiiAEfJ/BONO_3_SUSTITUCIONES.jpg';
export function PackSection() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      {/* 7. Qué Incluye */}
      <section className="py-20 px-4 bg-[#FAF6F0]" data-id="element-177">
        <div className="max-w-5xl mx-auto" data-id="element-178">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-violet-900 mb-12" data-id="element-179">
            Todo lo que vas a recibir
          </h2>

          <div className="space-y-6" data-id="element-180">
            {/* Producto Principal */}
            <div className="bg-white border-2 border-violet-300 rounded-3xl p-8 relative overflow-hidden shadow-md" data-id="element-181">
              <div className="absolute top-4 right-4 bg-violet-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-182">
                PRODUCTO PRINCIPAL
              </div>
              <h3 className="text-2xl font-bold text-violet-900 mb-3" data-id="element-183">
                20 Budines Irresistibles
              </h3>
              <p className="text-stone-700 text-lg" data-id="element-184">
                Recetario digital con 20 recetas paso a paso, fotos reales,
                ingredientes en gramos y mililitros, tiempos exactos y tips de
                cocción para que te salgan perfectos desde el primer intento.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-185">
              {/* Bono 1 - Emprendé */}
              <div className="bg-violet-50 border border-violet-200 rounded-3xl p-6 relative" data-id="element-186">
                <div className="w-10 h-10 bg-white/80 rounded-full flex items-center justify-center text-violet-700 font-bold text-xl mb-4" data-id="element-187">
                  1
                </div>
                <h4 className="text-xl font-bold text-violet-900 mb-2" data-id="element-188">
                  Emprendé: Guía Para Empezar a Vender
                </h4>
                <p className="text-stone-700" data-id="element-189">
                  Cómo calcular precios, presentar tus budines, conseguir tus
                  primeros clientes y armar pedidos por encargo desde tu casa.
                </p>
              </div>

              {/* Bono 2 - Conservá */}
              <div className="bg-[#F5EFE6] border border-stone-300 rounded-3xl p-6 relative" data-id="element-190">
                <div className="w-10 h-10 bg-white/80 rounded-full flex items-center justify-center text-violet-700 font-bold text-xl mb-4" data-id="element-191">
                  2
                </div>
                <h4 className="text-xl font-bold text-violet-900 mb-2" data-id="element-192">
                  Conservá: Guía de Freezado
                </h4>
                <p className="text-stone-700" data-id="element-193">
                  Aprendé a conservar tus budines hasta 3 meses sin perder
                  humedad ni sabor. Tiempos, temperaturas, cómo descongelar y
                  cómo evitar que se sequen.
                </p>
              </div>

              {/* Bono 3 - Sustituí */}
              <div className="bg-violet-100 border border-violet-300 rounded-3xl p-6 relative" data-id="element-194">
                <div className="w-10 h-10 bg-white/80 rounded-full flex items-center justify-center text-violet-700 font-bold text-xl mb-4" data-id="element-195">
                  3
                </div>
                <h4 className="text-xl font-bold text-violet-900 mb-2" data-id="element-196">
                  Sustituí: Tabla Maestra de Sustituciones
                </h4>
                <p className="text-stone-700" data-id="element-197">
                  Reemplazá azúcar, harinas, lácteos, huevos y grasas sin
                  arruinar la receta. Incluye versiones sin gluten, sin lactosa,
                  sin azúcar y veganas con equivalencias exactas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 8. Pack Composite */}
      <section className="py-20 px-4 bg-white" data-id="element-198">
        <div className="max-w-5xl mx-auto text-center" data-id="element-199">
          <h2 className="text-4xl md:text-5xl font-extrabold text-violet-900 mb-4" data-id="element-200">
            Tu pack completo
          </h2>
          <p className="text-xl text-stone-600 mb-16" data-id="element-201">
            Todo esto es tuyo hoy mismo
          </p>

          <div className="relative h-[350px] md:h-[500px] w-full max-w-4xl mx-auto cursor-pointer group" onClick={scrollToOffer} data-id="element-202">
            <div className="absolute inset-0 bg-violet-400/30 blur-[120px] rounded-full" data-id="element-203" />

            {/* Bono 1 */}
            <img src={IMG_BONO_1} alt="Bono 1" className="absolute w-[25%] left-[5%] top-[15%] -rotate-10 rounded-xl shadow-xl border-4 border-white transition-all duration-500 group-hover:-translate-x-8 group-hover:-rotate-12 object-cover aspect-[3/4]" data-id="element-204" />
            {/* Bono 2 */}
            <img src={IMG_BONO_2} alt="Bono 2" className="absolute w-[25%] right-[22%] top-[12%] rotate-6 rounded-xl shadow-xl border-4 border-white transition-all duration-500 group-hover:translate-x-4 group-hover:rotate-12 object-cover aspect-[3/4]" data-id="element-205" />
            {/* Bono 3 */}
            <img src={IMG_BONO_3} alt="Bono 3" className="absolute w-[25%] right-[5%] top-[18%] rotate-12 rounded-xl shadow-xl border-4 border-white transition-all duration-500 group-hover:translate-x-12 group-hover:rotate-[16deg] object-cover aspect-[3/4]" data-id="element-206" />
            {/* Main Product */}
            <img src={IMG_RECETARIO} alt="Recetario Principal" className="absolute w-[40%] left-[50%] -translate-x-[50%] top-[3%] z-30 rounded-2xl shadow-2xl border-4 border-white transition-transform duration-500 group-hover:scale-110 object-cover aspect-[3/4]" data-id="element-207" />
          </div>
        </div>
      </section>

      {/* 9. Sección de Bonos */}
      <section className="py-20 px-4 bg-violet-900 text-white" data-id="element-208">
        <div className="max-w-5xl mx-auto" data-id="element-209">
          <div className="text-center mb-16" data-id="element-210">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-211">
              3 Bonos exclusivos por tiempo limitado
            </h2>
            <p className="text-xl text-violet-200" data-id="element-212">
              Llevate estos complementos gratis con tu compra de hoy
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-213">
            {[{
            num: 1,
            title: 'Emprendé: Guía Para Empezar a Vender',
            desc: 'Cómo calcular precios, presentar tus budines, conseguir tus primeros clientes y armar pedidos por encargo desde tu casa.',
            val: 'USD 19',
            img: IMG_BONO_1
          }, {
            num: 2,
            title: 'Conservá: Guía de Freezado y Conservación',
            desc: 'Aprendé a conservar tus budines hasta 3 meses sin perder humedad ni sabor. Tiempos, temperaturas, cómo descongelar y cómo evitar que se sequen.',
            val: 'USD 14',
            img: IMG_BONO_2
          }, {
            num: 3,
            title: 'Sustituí: Tabla Maestra de Sustituciones',
            desc: 'Reemplazá azúcar, harinas, lácteos, huevos y grasas sin arruinar la receta. Incluye versiones sin gluten, sin lactosa, sin azúcar y veganas con equivalencias exactas.',
            val: 'USD 12',
            img: IMG_BONO_3,
            fullWidth: true
          }].map((bono, i) => <div key={i} onClick={scrollToOffer} className={`bg-white text-stone-900 rounded-2xl overflow-hidden flex flex-col sm:flex-row cursor-pointer hover:shadow-xl hover:scale-[1.02] transition-all ${bono.fullWidth ? 'md:col-span-2 md:max-w-3xl md:mx-auto w-full' : ''}`} data-id="element-214">
                <div className="w-full sm:w-2/5 relative bg-[#FAF6F0]" data-id="element-215">
                  <img src={bono.img} alt={bono.title} className="w-full h-full object-cover min-h-[220px]" data-id="element-216" />
                  <div className="absolute top-4 left-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-217">
                    GRATIS por hoy
                  </div>
                </div>
                <div className="w-full sm:w-3/5 p-6 flex flex-col justify-center" data-id="element-218">
                  <div className="flex items-center gap-2 text-violet-600 font-bold mb-2" data-id="element-219">
                    <Gift className="w-5 h-5" data-id="element-220" />
                    <span data-id="element-221">BONO {bono.num}</span>
                  </div>
                  <h4 className="text-xl font-bold text-violet-900 mb-3" data-id="element-222">
                    {bono.title}
                  </h4>
                  <p className="text-stone-600 text-sm mb-4 flex-grow" data-id="element-223">
                    {bono.desc}
                  </p>
                  <div className="flex items-center gap-3" data-id="element-224">
                    <span className="text-stone-400 line-through text-sm" data-id="element-225">
                      Valor: {bono.val}
                    </span>
                    <span className="text-green-600 font-bold" data-id="element-226">GRATIS</span>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="bg-violet-800/50 border border-violet-700 rounded-2xl p-6 text-center max-w-2xl mx-auto mb-10" data-id="element-227">
            <p className="text-xl font-medium text-violet-100" data-id="element-228">
              En total recibís 4 recursos completos valuados en{' '}
              <span className="font-bold text-white" data-id="element-229">USD 84</span>
            </p>
          </div>

          <div className="text-center" data-id="element-230">
            <button onClick={scrollToOffer} className="bg-green-500 hover:bg-green-600 text-white rounded-full py-4 px-10 font-bold text-xl shadow-[0_0_20px_rgba(34,197,94,0.4)] transition-all" data-id="element-231">
              QUIERO EL PACK + LOS BONOS
            </button>
          </div>
        </div>
      </section>
    </>;
}